import { isSameComboItems } from '../combo';
import logger from '~/services/logger';
import { IResponseComboItem } from '~/types/combo';
import { PRODUCT_TYPE } from '~/types/product';
import {
  IMenuProduct,
  IResponseProductExclusion,
  IResponseProductModifier,
  IResponseProductModifierOption,
  IResponseProductSize,
} from '~/types/products';

export const transformProductsFromCalculator = (
  products: IMenuProduct[] | undefined = [],
  productsFromCalculator: IMenuProduct[] | undefined = []
): IMenuProduct[] => {
  try {
    const updatedProducts = products.map((product: IMenuProduct, index) => {
      const findProduct: IMenuProduct | undefined = productsFromCalculator.find((_, calculatedIndex) => index === calculatedIndex);
      const isMeal: boolean = findProduct?.type === PRODUCT_TYPE.MEAL_COMBO;

      if (findProduct) {
        product.error = findProduct.error ? findProduct.error[0] : '';
        product.price = findProduct.price;
        product.orderable = 'orderable' in findProduct ? findProduct.orderable : true;
        product.status = findProduct.status;
        product.out_of_stock = findProduct.out_of_stock;
        product.order_type = findProduct.order_type;

        if (findProduct.modifiers?.length) {
          product.modifiers = _transformModifiers(product.modifiers, findProduct.modifiers);
        }

        if (findProduct.exclusions && product.exclusions?.length) {
          product.exclusions = _transformExclusions(product.exclusions, findProduct.exclusions);
        }

        if (findProduct.sizes && product.size && product.size.id) {
          product.size = _transformSize(product.size, findProduct.sizes);
        }

        if (findProduct.type) {
          product.items = _transformComboItems(product.items, findProduct.items, isMeal);
        }
      }

      return product;
    });

    return updatedProducts;
  } catch (err: any) {
    logger.error({ error: err, place: 'transformProductsFromCalculator' });
    return products;
  }
};

const _transformSize = (size: IResponseProductSize, sizesFromCalculator: IResponseProductSize[]): IResponseProductSize => {
  const findSize: IResponseProductSize | undefined = sizesFromCalculator.find((item) => item.id === size.id);

  if (findSize) {
    size.price = findSize.price;
    size.error = findSize.error || '';
  }

  return size;
};

const _transformModifiers = (
  modifiers: IResponseProductModifier[] | undefined,
  modifiersFromCalculator: IResponseProductModifier[] | undefined
): IResponseProductModifier[] => {
  if (!modifiers?.length || !modifiersFromCalculator?.length) return modifiers || [];

  return modifiers?.map((modifier) => {
    const findModifier: IResponseProductModifier | undefined = modifiersFromCalculator?.find((item) => item.id === modifier.id);

    if (findModifier) {
      modifier.error = findModifier.error ? findModifier.error[0] : '';
      modifier.options = _transformModifierOptions(modifier.options, findModifier.options);
    }

    return modifier;
  });
};

const _transformModifierOptions = (
  options: IResponseProductModifierOption[] | undefined,
  optionsFromCalculator: IResponseProductModifierOption[] | undefined
): IResponseProductModifierOption[] => {
  if (!options?.length || !optionsFromCalculator?.length) return options || [];

  return options.map((option) => {
    const findOption: IResponseProductModifierOption | undefined = optionsFromCalculator.find((item) => item.id === option.id);

    if (findOption) {
      option.price = findOption.price;
      option.error = findOption.error ? findOption.error[0] : '';
    }

    return option;
  });
};

const _transformExclusions = (
  exclusions: IResponseProductExclusion[] | undefined,
  exclusionsFromCalculator: IResponseProductExclusion[] | undefined
): IResponseProductExclusion[] => {
  if (!exclusions?.length || !exclusionsFromCalculator?.length) return exclusions || [];

  return exclusions.map((exclusion) => {
    const findExclusion: IResponseProductExclusion | undefined = exclusionsFromCalculator.find((item) => item.id === exclusion.id);

    if (findExclusion) {
      exclusion.error = findExclusion.error ? findExclusion.error[0] : '';
    }

    return exclusion;
  });
};

const _transformComboItems = (
  items: IResponseComboItem[] | undefined,
  itemsFromCalculator: IResponseComboItem[] | undefined,
  isMeal: boolean
): IResponseComboItem[] => {
  if (!items?.length || !itemsFromCalculator?.length) return items || [];

  if (isMeal) {
    return items.map((item) => {
      const findItem: IResponseComboItem | undefined = itemsFromCalculator.find((_item) => isSameComboItems(_item, item));

      if (findItem) {
        item.out_of_stock = findItem.out_of_stock;
        item.status = findItem.status;
        item.price = findItem.price;
        item.error = findItem.error ? findItem.error[0] : '';
        item.modifiers = _transformModifiers(item.modifiers, findItem.modifiers);
        // TODO: combo exclusions
        // item.exclusions = _transformExclusions(item.exclusions, findItem.exclusions)
      }

      return item;
    });
  }

  return itemsFromCalculator.map((item) => {
    const findItem: IResponseComboItem | undefined = itemsFromCalculator.find((_item) => _item.id === item.id);

    if (findItem) {
      item.error = findItem.error ? findItem.error[0] : '';
    }

    return item;
  });
};
